import React from "react";
import "./App.css";
import Hero from "./components/Hero";
import About from "./components/About";
import WhatIDo from "./components/WhatIDo";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <Hero />
      <About />
      <WhatIDo />
      <Projects />
      <Skills />
      <Experience />
      <Contact />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
